const Pages = {
  tableOfContent: {
    count(count, sections) {
      return Math.ceil((count * Math.ceil(sections / 2)) / 2);
    },
  },
  mainSynthesis: {
    size: 5,
    count(count, repeat) {
      return Math.ceil(count / this.size) * repeat + 1;
    },
  },
  synthesis: {
    size: 5,
    count(count) {
      return Math.ceil(count / this.size) + 1;
    },
  },
  transit: {
    size: 5,
    count(count) {
      return Math.ceil(count / this.size) + 1 + 2;
    },
  },
  impact: {
    size: 5,
    count(count) {
      return 1 + Math.ceil(count / this.size) * 2 + 1;
    },
  },
  outlier: {
    size: 5,
    count(count) {
      return Math.ceil(count / this.size) + 1;
    },
  },
  environmental: {
    size: 5,
    count(count) {
      return Math.ceil(count / this.size) + 1;
    },
  },
};

const Accountable = (pages, count) => {
  const cumulativeSum = ([head, ...tail]) =>
    tail.reduce(
      (acc, c, index) => {
        acc.push({
          key: c.key,
          count: acc[index].count + c.count,
        });
        return acc;
      },
      [head],
    );

  const myPages = pages.reduce((acc, key) => {
    acc.push({
      key,
      count: Pages[key].count(count),
    });
    return acc;
  }, []);

  return cumulativeSum(myPages);
};

export { Pages, Accountable };
